import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=7fb1c864&"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fb1c864')) {
      api.createRecord('7fb1c864', component.options)
    } else {
      api.reload('7fb1c864', component.options)
    }
    module.hot.accept("./ConfirmationModal.vue?vue&type=template&id=7fb1c864&", function () {
      api.rerender('7fb1c864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/modal/ConfirmationModal.vue"
export default component.exports